import { InformationalModalContextType } from '../types/InformationalModalContextType';

export const informationalModalInitValue: InformationalModalContextType = {
  data: {
    alias: 'OP_ALIAS_CANJE',
    date: '',
    comments: '',
    file: undefined,
    lastOperationDate: '',
    selectedParticipants: [],
    participantOptions: [],
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeAlias(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeParticipants(): void {},
    handleSaveInformational(): void {},
  },
};
